<template>
  <MinimalLayout :allowAnonymous="true" v-if="preloaded">
    <div class="container-fluid">
      <section class="vh-100">
        <div class="row vh-100">
          <div class="col-md-6 d-flex align-items-center justify-content-center vh-25 bg-cover bg-center"
            :style="`background-image: url(${loginImagePath});`"></div>
          <div class="col-md-6 d-flex align-items-center justify-content-center vh-25 bg-cover bg-center">
            <div class="d-flex align-items-center text-center">
              <form @submit.prevent="submit" :class="{ submitting: submitted }">
                <img class="img-fluid mb-4 w-75" :src="defaultLogoUrl" :alt="defaultCompanyAlias" srcset="">
                <div class="alert alert-danger" v-if="errorMessage">{{ errorMessage }}</div>
                <div>
                  <h3 class="mb-3">{{ i18n('Recover Password') }}</h3>
                  <p v-if="!completed">
                    {{ helpText }}
                  </p>
                </div>
                <template v-if="!completed">
                  <div class="row g-2 mb-2">
                    <div class="col-12">
                      <Field :label="i18n('Username')" type="text" v-model="formData.username" :disabled="submitted"
                        :required="true" :errorMessage="errorMessages.username" />
                    </div>
                  </div>
                  <div class="d-grid mb-3 mt-4">
                    <button type="submit" class="btn btn-dark btn-dark-petrol" :disabled="submitted">
                      <span v-if="submitted" class="spinner-border spinner-border-sm" role="status">
                        <span class="visually-hidden"> {{ i18n('Sending ...') }}</span>
                      </span>
                      {{ i18n('Confirm') }}
                    </button>
                  </div>
                </template>
                <template v-else>
                  <p>
                    {{ confirmText }}
                  </p>
                </template>
              </form>
            </div>
          </div>
        </div>
      </section>
    </div>
  </MinimalLayout>
  <div class="p-5 text-center" v-else>
    <span class="spinner-border spinner-border-sm" role="status">
      <span class="visually-hidden">
        {{ i18n('Loading...') }}
      </span>
    </span>
  </div>
</template>

<script>
import $env from '@/tools/environment.js';
import api from "@/api.js";
import { canAccessPage } from "@/routeAcl.js";
import { duplicate, } from '@/tools/object.js';
import { translatedErrorMessage, } from "@/tools/errorHandling.js";
import MinimalLayout from "@/layouts/MinimalLayout.vue";
import Field from "@/components/common/form/Field.vue";

const defaultLogoUrl = $env('VITE_DEFAULT_LOGO_URL');
const defaultCompanyAlias = $env('VITE_DEFAULT_COMPANY_ALIAS');
const loginImagePath = $env('VITE_DEFAULT_LOGIN_IMAGE');

export default {
  components: {
    MinimalLayout,
    Field,
  },
  data() {
    return {
      preloaded: false,
      formData: {},
      errorMessage: '',
      errorMessages: {},
      submitted: false,
      loginImagePath,
      defaultLogoUrl,
      defaultCompanyAlias,
      helpText: null,
      completed: false,
    };
  },
  created() {
    this.helpText = this.i18n('If the user is registered on the site, he or she will receive and email with a link to reset the account password.');
    this.confirmText = this.i18n('A password reset link will be emailed to you momentarily.');

    const checkAccess = (user) => {
      if (user?.loggedIn || !canAccessPage(this.$route?.name, null, this.$root.features)) {
        this.$router.push({ name: 'Index' });
      } else {
        this.preloaded = true;
      }
    };

    api.auth().then(checkAccess).catch(checkAccess);
  },
  methods: {
    submit() {
      this.errorMessage = '';
      this.errorMessages = {};
      this.submitted = true;
      this.completed = false;

      const postFormData = duplicate(this.formData);

      api.post('users/sendPasswordRecoveryMail', postFormData).then(codeResult => {
        this.completed = true;
      }).catch((errorMessage) => {
        this.errorMessage = translatedErrorMessage(errorMessage);
        this.submitted = false;
      });
    },
  },
};
</script>

<style lang="scss" scoped>
form {
  max-width: 320px;
}
</style>